import { useState, useEffect, useMemo } from 'react';
import UserProfile from '../models/UserProfile';
import { database, supabase } from '../lib/supabase';
import { useUserProfile } from './useUserProfile';

interface FlatCountByBudget {
  budget_range: number;
  flat_count: number;
}

const useFlatCountsByBudget = (postcodes?: string[], minRooms?: number, minRoomSize?: number) => {
  const [flatCounts, setFlatCounts] = useState<FlatCountByBudget[] | null>(null);

  useEffect(() => {
    const fetchFlatCounts = async () => {
      try {
        const { data, error } = await supabase.rpc('get_budget_chart_data', {
          postcodes: postcodes ?? null,
          min_rooms: minRooms ?? null,
          min_size: minRoomSize ?? null
        })
          .select('budget_range, flat_count')
          .order('budget_range', { ascending: true });

        if (error) throw error;

        if (data) {
          const flatCountsArray: FlatCountByBudget[] = [];
          for (let budget = 0; budget <= 3000; budget += 100) {
            const existingData = data.find(item => Number(item.budget_range) === budget);
            flatCountsArray.push({
              budget_range: budget,
              flat_count: existingData ? Number(existingData.flat_count) : 0
            });
          }

          setFlatCounts(flatCountsArray);
        }
      } catch (err) {
        console.error('Error fetching flat counts:', err);
        setFlatCounts([]);
      }
    };

    fetchFlatCounts();
  }, [postcodes, minRooms, minRoomSize]);

  return { flatCounts };
};

export default useFlatCountsByBudget;